module.exports = __webpack_public_path__ + "img/source_03.b400a2a6.png";